export default __webpack_public_path__ + "static/media/H0002.090a5d1d.png";